import React, { useState } from 'react';
import NoteTypes from './note-types/NoteTypes';
import NotePriorities from './note-priorities/NotePriorities';
import styles from '../../Configurations.module.css';

const GeneralSettings = () => {
    const [activeTab, setActiveTab] = useState('noteTypes');

    const tabs = [
        { id: 'noteTypes', label: 'Note Types', component: NoteTypes },
        { id: 'notePriorities', label: 'Note Priorities', component: NotePriorities },
        // Add more tabs here as needed
    ];

    const ActiveComponent = tabs.find(tab => tab.id === activeTab)?.component || NoteTypes;

    return (
        <div className={styles.section}>
            <div className={styles.sectionHeader}>
                <h2>General Settings</h2>
                <p>Configure general system settings and parameters.</p>
            </div>

            <div className={styles.tabContainer}>
                <div className={styles.tabNav}>
                    {tabs.map(tab => (
                        <button
                            key={tab.id}
                            onClick={() => setActiveTab(tab.id)}
                            className={`${styles.tabButton} ${activeTab === tab.id ? styles.active : ''}`}
                        >
                            {tab.label}
                        </button>
                    ))}
                </div>

                <div className={styles.tabContent}>
                    <ActiveComponent />
                </div>
            </div>
        </div>
    );
};

export default GeneralSettings;
